export default function RecordDate({ record }) {
    return (
        <p className='pt-2 text-sm'>{record || ""}</p>
    )
}
